import React, { useEffect, useState } from 'react';
import { useTheme } from '../../../contexts/ThemeContext';
import SwimLaneTimeline, { TimelineLane } from '../../common/SwimLaneTimeline';
import api from '../../../services/api';

interface Props {
  manifestId: string;
}

const HydrationTimeline: React.FC<Props> = ({ manifestId }) => {
  const { darkMode } = useTheme();
  const [lanes, setLanes] = useState<TimelineLane[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get(`/cross-system/links/artifact/${manifestId}`)
      .then(r => {
        const links = r.data || [];
        // Group by node path (from metadata) into lanes
        const pathMap = new Map<string, any[]>();
        links.forEach((l: any) => {
          const path = l.metadata?.node_path || 'unknown';
          const dir = path.split('/')[0] || '/';
          if (!pathMap.has(dir)) pathMap.set(dir, []);
          pathMap.get(dir)!.push({
            id: l.id,
            start: l.created_at,
            label: path,
            status: 'success' as const,
            metadata: l.metadata,
          });
        });

        setLanes(Array.from(pathMap.entries()).map(([dir, events]) => ({
          id: dir,
          label: dir + '/',
          color: '#06b6d4',
          events,
        })));
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [manifestId]);

  if (loading) return <div className={`text-sm ${darkMode ? 'text-gray-500' : 'text-gray-400'}`}>Loading timeline...</div>;

  if (lanes.length === 0) {
    return (
      <div className={`p-8 text-center rounded-lg border ${darkMode ? 'border-gray-700 text-gray-500' : 'border-gray-200 text-gray-400'}`}>
        No hydration events recorded yet. Hydrate nodes to see the timeline.
      </div>
    );
  }

  return (
    <div className={`rounded-xl border p-4 ${darkMode ? 'bg-gray-800/50 border-gray-700' : 'bg-white border-gray-200'}`}>
      <div style={{ height: Math.max(lanes.length * 48 + 60, 200) }}>
        <SwimLaneTimeline lanes={lanes} />
      </div>
    </div>
  );
};

export default HydrationTimeline;
